import store from '../store';
import {
  commonLoginAction,
  resetAuthLoading,
  saveToken,
  setAuthLoading,
  setEmailVerifyData,
} from '../actions/authActions';
import { killLoading } from '../actions/commonActions';
import { signupCheck } from '../sdk';
import { removeLocalItem, setLocalItem } from '../common';

export const initGoogleScript = (): void => {
  const script = document.createElement('script');

  if (window.gapi && window.gapi.auth2) {
    return;
  }

  script.src = process.env.REACT_APP_GOOGLE_JS;
  script.defer = true;
  script.onload = () => window.gapi && window.gapi.load('auth2');
  document.body.appendChild(script);
};

export const googleAuth = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      const resolveAuth2 = () => {
        const auth = window.gapi.auth2.init({ client_id: process.env.REACT_APP_EXTERNAL_GOOGLE_CLIENT_ID });

        resolve(auth);
      };

      if (window.gapi && typeof window.gapi.load === 'function' && !window.gapi.auth2) {
        return window.gapi.load('auth2', resolveAuth2);
      }

      resolveAuth2();
    } catch (error) {
      reject(error);
    }
  });
};

// login
const checkSignup = async (data: any, type: string): Promise<any> => {
  try {
    const { data: responseData } = await signupCheck(data);

    // assume that the signin check is valid we can proceed to form fillup
    if (responseData.length === 0) {
      if (data.email) {
        removeLocalItem('join_predata');
        setLocalItem('join_predata', JSON.stringify(data));
      }

      store.dispatch(resetAuthLoading());
      store.dispatch(killLoading());
      window.location.href = '/join';
      return 'redirected'; // Return indicator to prevent finally block from toggling loading state
    }

    if ('token' in responseData) {
      store.dispatch(saveToken({ token: responseData.token }));
      store.dispatch(commonLoginAction(type));
    }
  } catch (e) {
    const error =
      (e?.response?.data?.email && e.response.data.email[0]) ||
      (e?.response?.data?.password && e?.response?.data?.password[0]) ||
      (e?.response?.data?.errors && e?.response?.data?.errors[0].code && { errorCode: e.response.data.errors[0].code });

    if ([40101001, 40001906, 40101009].includes(error?.errorCode)) {
      store.dispatch(
        setEmailVerifyData({
          email: data.email,
          redirectTo: 'none',
          hasError: true,
          socialError: true,
          error: {
            errorCode: error.errorCode,
            message: 'Invalid email and/or password combination.',
          },
        })
      );
      return;
    }

    if ([40101010, 40101007, 40101015, 40101014].includes(error?.errorCode)) {
      //fraud deleted and suspended redirect to fraud delete and suspend error handling screen
      store.dispatch(setEmailVerifyData({ email: data.email, redirectTo: 'email_error', errorCode: error?.errorCode }));
      return;
    }
  }
};

const loginWithSocial = async (params: { site: string; email: string; token: string }, type: string): Promise<any> => {
  let shouldResetLoading = true;

  try {
    const { token, site, email } = params;
    const preData = { token, site, email };

    store.dispatch(setAuthLoading());

    const result = await checkSignup(preData, type);

    // If checkSignup returns a redirect indicator, don't reset loading in finally
    if (result === 'redirected') {
      shouldResetLoading = false;
    }
  } catch (error) {
    console.warn(error);
  } finally {
    // Only reset loading if we didn't redirect (redirect clears it in checkSignup)
    if (shouldResetLoading) {
      store.dispatch(setAuthLoading());
      store.dispatch(killLoading());
    }
  }
};

// login
const googleSignUp = async (): Promise<any> => {
  try {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    const auth = await _googleAuth();

    return await auth.signIn({ prompt: 'select_account' });
  } catch (error) {
    console.warn(error);
  }
};

export { googleSignUp, checkSignup, loginWithSocial };
